export default "__VITE_PUBLIC_ASSET__19194319__"